import { Controller } from "@hotwired/stimulus";

// Shows a reassurance note when the link type changes on an existing profile
export default class extends Controller {
  static targets = ["note"];
  static values = { original: String };

  changed(event) {
    if (!this.hasNoteTarget) return;
    this.noteTarget.classList.toggle(
      "is-hidden",
      event.target.value === this.originalValue
    );
  }
}
